import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListItem from "~/components/collaborators/slide-item";
import alertModal from "~/components/collaborators/alert-modal";
import newTeamModal from "~/components/collaborators/new-team-modal";
import newSellerModal from "~/components/collaborators/new-seller-modal";
import loader from "~/components/modals/loader";
import { mapState, mapActions } from "vuex";
import { NoContentError } from "~/abstractions/errors";

export default {
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                app = _ref.app,
                params = _ref.params,
                redirect = _ref.redirect;
            var value;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            value = Number(params.id);
                            _context.next = 4;
                            return store.dispatch("team/loadDateTeam", {
                                id: value
                            });

                        case 4:
                            _context.next = 9;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context["catch"](0);

                            if (_context.t0 instanceof NoContentError) redirect("/channels");else app.$controlMessage(_context.t0);

                        case 9:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 6]]);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),
    asyncData: function asyncData(_ref3) {
        var app = _ref3.app,
            redirect = _ref3.redirect;

        if (app.$isAdmin()) {
            return redirect("/bosses");
        } else if (app.$isSupervisor()) {
            return redirect("/my-team");
        }
        return null;
    },

    components: {
        ListItem: ListItem,
        alertModal: alertModal,
        newTeamModal: newTeamModal,
        newSellerModal: newSellerModal,
        loader: loader
    },
    data: function data() {
        var _$store$state$team$da = this.$store.state.team.dataTeam,
            Name = _$store$state$team$da.Name,
            IsActive = _$store$state$team$da.IsActive,
            IdTeam = _$store$state$team$da.IdTeam;

        var status = IsActive == true ? "Equipo Activo" : "Equipo Inactivo";
        return {
            titlePrincipal: Name,
            typeState: status,
            statusTeam: IsActive,
            conditionalNotContent: false,
            messageNotContent: "No hay Vendedores asignados a este Equipo",
            buttonAddColaborator: true,
            collaboratorsTitle: "Vendedores",
            typeOfTable: "DetailTeam",
            buttonNewCollaborator: "Nuevo vendedor",
            idTeam: IdTeam,
            loaderText: "Procesando información"
        };
    },

    methods: {
        prevPage: function prevPage() {
            this.$router.push("/channels");
        },
        openEdit: function openEdit() {
            //this.$refs.newTeamModal.channelIsActive = this.statusTeam
            this.$refs.newTeamModal.idTeam = this.idTeam;
            this.$refs.newTeamModal.editModalConfig();
        },
        editSellerTable: function editSellerTable(val) {
            this.$refs.loaderModal.showLoader();
            this.$router.push("/channels/teams/" + this.idTeam + "/sellers/" + val.item.value);
        },
        openNewItem: function openNewItem() {
            // console.log('teamIsActive')
            this.$refs.newSellerModal.teamIsActive = this.statusTeam;
            this.$refs.newSellerModal.value = this.idTeam;
            this.$refs.newSellerModal.addNewSeller();
        },
        completeForm: function completeForm() {
            this.$refs.alertModal.openModal();
        },
        toTeamsTable: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(val) {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.titlePrincipal = val.val.name;
                                this.typeState = val.val.active == true ? "Equipo Activo" : "Equipo Inactivo";
                                this.statusTeam = val.val.active;

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function toTeamsTable(_x2) {
                return _ref4.apply(this, arguments);
            }

            return toTeamsTable;
        }(),
        editTeamModal: function editTeamModal() {
            // console.log('editTeamModal')
        },
        upDateTeam: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var response;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$store.dispatch("team/list", {
                                    id: this.idTeam
                                });

                            case 2:
                                response = _context3.sent;
                                return _context3.abrupt("return", response);

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function upDateTeam() {
                return _ref5.apply(this, arguments);
            }

            return upDateTeam;
        }(),
        isContent: function isContent() {
            var constant = this.listOfTeam[0].items.length;
            if (constant == 0) {
                this.$refs.newTeamModal.isHaveNotSellers = true;
                this.conditionalNotContent = true;
                this.$refs.newSellerModal.conditionalIsSupervisor = true;
            } else {
                this.$refs.newSellerModal.conditionalIsSupervisor = false;
                this.conditionalNotContent = false;
                this.$refs.newTeamModal.isHaveNotSellers = false;
            }
        },
        notShowContent: function notShowContent() {
            this.$refs.newSellerModal.conditionalIsSupervisor = false;
            this.conditionalNotContent = false;
        },
        addNewItem: function addNewItem(val) {
            // console.log('addNewItem', val)
        }
    },
    computed: _extends({}, mapState({
        listOfTeam: function listOfTeam(state) {
            return state.team.teams;
        }
    })),
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.isContent();
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/channels/teams/_id/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/channels/teams/_id/index.vue
// module chunks = 8